import {
  CloseIcon,
  Div,
  MediumFilledButton,
  MediumOutlineButton,
  Text2,
  Text3
} from "components/Base";
import MiniModalWrapper from "ui-kit/MiniModalWrapper";
import React from "react";

const UnsavedChangesModal = ({
  hideSaveChangesModal,
  proceedWithoutSaving
}) => (
  <MiniModalWrapper
    style={{ width: "335px" }}
    showModal
    stopPropagation
    isPortal={false}
    showHeader={false}
  >
    <Div bg="white" width={1} style={{ borderRadius: "6px" }}>
      <Div
        px={5}
        py={4}
        display="row.space-between.center"
        style={{ borderBottom: "1px solid #E7E6EA" }}
      >
        <Text3 bold>Unsaved changes</Text3>
        <CloseIcon
          onClick={hideSaveChangesModal}
          color={"neutral7"}
          sizeWFS={3}
        />
      </Div>
      <Div px={5} pt={3} pb={5} style={{ borderBottom: "1px solid #E7E6EA" }}>
        <Text2>
          You have unsaved changes. Would you like to save them before
          proceeding?
        </Text2>
      </Div>
      <Div p={5} display="row.flex-start.center" style={{ gap: "8px" }}>
        <MediumFilledButton
          width={0.5}
          className="accentable-primary-button"
          onClick={proceedWithoutSaving}
          bg="primary7"
        >
          Yes
        </MediumFilledButton>
        <MediumOutlineButton width={0.5} onClick={hideSaveChangesModal}>
          Cancel
        </MediumOutlineButton>
      </Div>
    </Div>
  </MiniModalWrapper>
);

export default UnsavedChangesModal;
